@if (isBlockedUIActive()) {
<div class="blocked-overlay">
  <ng-lottie width="400px" [options]="options" />
</div>
}
<app-confirm-popup> </app-confirm-popup>
<router-outlet />
